export default __webpack_public_path__ + "static/media/KiaFavicon.c063aaef.ico";